import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ExerciceCategory } from "../../../common/models/exercice-category";
import { NgIf } from "@angular/common";
import { MatTooltip } from "@angular/material/tooltip";
import { Exercice } from "../../../common/models/exercice";

@Component({
  selector: 'exercice-category-thumbnail',
  providers: [],
  styleUrls: ['./exercice-category-thumbnail.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatTooltip
  ],
  templateUrl: './exercice-category-thumbnail.html'
})
export class ExerciceCategoryThumbnailComponent implements OnInit{
    @Input() public data: ExerciceCategory = new ExerciceCategory({});
    @Input() public hideText = false;
    @Input() public chipSize = 10;
    @Input() public showAsTag = false;
    @Input() public isMobileDisplay = false;

    // C'est obligé car les Session Items Rows ont un data en any et donc les translations ne sont pas process avant
    ngOnInit(): void {
      this.data = ExerciceCategory.fromAPI(this.data);
    }
}
